'use client';

import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { Button } from '@medsimples/design-system/src/components';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useDesignTokens } from '../../app/providers/design_tokens_provider';
import BackButton from '../BackButton';
import Countdown from '../Countdown';
import { OTPInput } from './OTPInput';

export const DEFAULT_OTP_RESET_COUNTDOWN = 180_000;

// TODO?: make texts customizable?
interface Props {
  onClickVerify: (code: string) => Promise<unknown>;
  onClickResend: () => unknown;
  onBackButtonAction?: () => unknown;
  timeLeft: number;
  infoText?: string;
}

export function OTPForm(props: Props) {
  const {
    onClickVerify,
    onClickResend,
    onBackButtonAction,
    timeLeft,
    infoText: infoTextProp,
  } = props;
  const tokens = useDesignTokens();
  const router = useRouter();

  const [isLoading, setLoading] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [isVerificationCodeInvalid, setIsVerificationCodeInvalid] =
    useState(false);

  const isResendEnabled = timeLeft <= 0;
  const infoText = infoTextProp ?? 'Insira os 6 dígitos enviados';

  const resendStyle = isResendEnabled
    ? {
        textDecoration: 'underline',
        cursor: 'pointer',
      }
    : { cursor: 'not-allowed' };

  return (
    <>
      <Box marginBottom={3}>
        <Text
          colorScheme={tokens.text.primary.color}
          textAlign='center'
          fontWeight='bold'
          fontSize='3xl'
        >
          PIN de verificação
        </Text>
      </Box>

      <Box justifyContent={'center'} marginBottom={9}>
        <Text
          textAlign='center'
          fontSize='md'
          colorScheme={tokens.text.primary.color}
        >
          {infoText}
        </Text>
      </Box>

      <Box marginBottom={10}>
        <OTPInput
          isInvalid={isVerificationCodeInvalid}
          value={verificationCode}
          onChange={setVerificationCode}
          placeholder=''
        />
      </Box>

      <Box w='100%'>
        <Button
          onClick={onVerify}
          isLoading={isLoading}
          colorScheme={tokens.button.primary.scheme}
        >
          Verificar
        </Button>
      </Box>

      <BackButton router={router} marginTop={5} action={onBackButtonAction} />

      <Box textColor={isResendEnabled ? 'black' : 'gray'}>
        <VStack>
          <Text
            as='a'
            onClick={() => {
              if (isResendEnabled) {
                onClickResend();
              }
            }}
            fontSize='lg'
            {...resendStyle}
          >
            Reenviar código
          </Text>

          {!isResendEnabled && (
            <HStack>
              <Text fontSize='sm'>Aguarde</Text>
              <Countdown count={timeLeft} fontSize='sm' />
            </HStack>
          )}
        </VStack>
      </Box>
    </>
  );

  function onVerify() {
    setLoading(true);
    onClickVerify(verificationCode).finally(() => setLoading(false));
  }
}
